'use client';

import '@/styles/globals.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { APIProvider as GoogleMapsAPIProvider } from '@vis.gl/react-google-maps';
import { FC, PropsWithChildren } from 'react';
import { ZipProvider } from '../../../context/ZipContext';

const queryClient = new QueryClient();

export const IFrameEntryPoint: FC<PropsWithChildren> = ({ children }) => {
  return (
    <main>
      <QueryClientProvider client={queryClient}>
        <ZipProvider>
          {process.env.NEXT_PUBLIC_ENABLE_GOOGLE_API === 'true' ? (
            <GoogleMapsAPIProvider
              apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_CLIENT || ''}
              libraries={['places']}
            >
              {children}
            </GoogleMapsAPIProvider>
          ) : (
            children
          )}
        </ZipProvider>
      </QueryClientProvider>
    </main>
  );
};
